export const productStickyBar = () => {
    document.addEventListener('DOMContentLoaded', async () => {

        let FixedVariantItem = class extends HTMLElement{
            constructor(){
                super();

                this.variantItemSelected.addEventListener("click", this.onVariantSelectedClick.bind(this));
            }

            connectedCallback(){
                
            }

            onVariantSelectedClick = function(){
                if(!this.classList.contains("active")){
                    this.clearDropdown();
                }
                this.classList.toggle("active");
            }

            clearDropdown = function(){
                const fixedVariantItems = document.querySelectorAll(".fixed-variant-item");
                fixedVariantItems.forEach(function (fixedVariantItem) {
                    fixedVariantItem.classList.remove('active');
                })
            }

            get variantItemSelected(){
                return this.querySelector('.variant-selected');
            }

        }

        if (!window.customElements.get("fixed-variant-item")) {
            window.customElements.define("fixed-variant-item", FixedVariantItem);
        }

        const FixedSizeChartVariant = class extends FixedVariantItem{
            constructor(){
                super();

                let self = this;
                this.sizeChartItems.forEach((item) => {
                    item.addEventListener("click", self.onSizeChartClick.bind(self))
                })
            }

            connectedCallback(){
                
            }

            onSizeChartClick = function(event){
                event.preventDefault();
                this.classList.remove('active');
                const sizeVal = event.currentTarget.getAttribute('href');
                if(this.productSizeVariant != undefined){
                    this.productSizeVariant.value = sizeVal;
                    this.productSizeVariant.dispatchEvent(new Event("change"))
                }
            }

            get sizeChartItems(){
                return this.querySelectorAll("a");
            }

            get productSizeVariant(){
                return document.querySelector('#product_size_variation');
            }
        }

        if (!window.customElements.get("fixed-sizechart-variant")) {
            window.customElements.define("fixed-sizechart-variant", FixedSizeChartVariant);
        }

        let FixedColorVariant = class extends FixedVariantItem{
            constructor(){
                super();

                let self = this;
                this.variantItemSelected.addEventListener("click", this.sliderLineInit.bind(this));
                this.colorVariantItems.forEach((item) => {
                    item.addEventListener("click", self.onColorVariantChange.bind(self));
                })

                document.addEventListener('variant:change', this.onVariantChange.bind(this));

                this.colorCatItems.forEach((item) => {
                    item.addEventListener("click", self.onCatNavClick.bind(self));
                })
            }

            sliderLineInit = function() {
                const actWidth = this.colorCatActive.offsetWidth;
                const actPosition = this.colorCatActive.getBoundingClientRect();
                this.colorSliderLine.style.left = actPosition.left + "px";
                this.colorSliderLine.style.width = actWidth + "px";
            }

            onColorVariantChange = function(event){
                event.preventDefault();
                this.classList.remove("active");
                const variantId = event.currentTarget.getAttribute('data-color-variant-id');
                const variantText = event.currentTarget.querySelector(".val").textContent;
                this.querySelectorAll(".dv-item").forEach(function (dv) {
                    dv.classList.remove('selected');
                })
                event.currentTarget.closest(".dv-item").classList.add("selected");
                this.variantItemSelected.querySelector(".value").textContent = variantText;

                let colorVariant = document.querySelector('.color-swatch-wrapper label[data-variant-id="' + variantId + '"]');
                if(colorVariant){
                    colorVariant.click();
                }
            }

            onVariantChange = function(event){
                let self = this;
                const variant = event.detail.variant;
                // Set sticky color variant
                const colorItems = this.querySelectorAll(".dv-item");
                colorItems.forEach(function (colorItem) {
                    const colorVariantId = colorItem.querySelector('.fixed--color-picker').getAttribute('data-color-variant-id');
                    if(colorVariantId != variant.id){
                        colorItem.classList.remove("selected");
                    }else{
                        colorItem.classList.add("selected");
                        self.variantItemSelected.querySelector('.value').textContent = colorItem.textContent;
                    }
                })

                // Update email button by variant
                let emailButton = document.querySelector(".sticky-email-button");
                let submitButton = document.querySelector('.stickybar-submit');
                
                if(emailButton) {
                    if (!variant.available) {
                        emailButton.classList.remove('disabled');
                        submitButton.classList.add('disabled');
                    }else{
                        emailButton.classList.add('disabled');
                        submitButton.classList.remove('disabled');
                    }
                }

                setTimeout(function(){
                    const preOrder = document.querySelector('input[name="properties\[Preorder\]"]');
                    submitButton.innerHTML = preOrder.value ? window.themeVariables.strings.preOrderButton : window.themeVariables.strings.addToCartButton;
                    if(submitButton.classList.contains('has-accessories')){
                        submitButton.innerHTML = 'オプションを選択';
                    }
                }, 100);
                
            }

            onCatNavClick = function(event){
                event.preventDefault();

                const thisPosition = event.currentTarget.getBoundingClientRect();
                const width = thisPosition.width;

                this.colorSliderLine.style.left = thisPosition.left + "px";
                this.colorSliderLine.style.width = width + "px";

                const tabId = event.currentTarget.getAttribute("data-tab-id");
                this.querySelectorAll(".color-cat-tab-content .cat-tab-content").forEach(function (tabContent) {
                    tabContent.classList.remove("show");
                })
                this.colorCatItems.forEach(function (item) {
                    item.classList.remove("active");
                })
                event.currentTarget.classList.add("active");
                let tabElement = this.querySelector("#" + tabId);
                if(tabElement){
                    tabElement.classList.add("show");
                }
            }

            get colorCatActive(){
                return this.querySelector(".color-cat-nav .active");
            }

            get colorSliderLine(){
                return this.querySelector(".color-cat-nav .slider-line");
            }

            get colorVariantItems(){
                return this.querySelectorAll(".dv-item a");
            }

            get colorCatItems(){
                return this.querySelectorAll(".color-cat-nav a");
            }

        }

        if (!window.customElements.get("fixed-color-variant")) {
            window.customElements.define("fixed-color-variant", FixedColorVariant);
        }


        let emailButton = document.querySelector(".sticky-email-button");
        emailButton.addEventListener('click', function (e) {
            e.preventDefault();
            let emailBIS = document.getElementById("BIS_trigger");
            if(emailBIS) {
                emailBIS.click();
            }
        })

        function stickyProductBar() {
            let stickyBar = document.querySelector("product-sticky-bar");
            const form = document.querySelector(".product-info__block-item form");
            const footer = document.querySelector(".footer");
            if((window.pageYOffset < form.offsetTop - window.innerHeight || window.pageYOffset > form.offsetTop + form.offsetHeight) && (window.pageYOffset < footer.offsetTop - window.innerHeight)){
                stickyBar.classList.add('is-visible-sp');
            }else{
                stickyBar.classList.remove('is-visible-sp');
            }
            document.body.classList.toggle('first-view', window.pageYOffset === 0);
            if(window.pageYOffset === 0){
                document.body.classList.add("sticky-menu");
            }
        }

        stickyProductBar();
        document.addEventListener('scroll', function () {
            stickyProductBar();
        })

        function moveStickyBar() {
            const productStickyBar = document.querySelector('.product-sticky-bar');
            if(productStickyBar) {
                if (window.innerWidth > 767){
                    document.querySelector('.shopify-section--header').appendChild(productStickyBar);
                }else{
                    document.querySelector('.shopify-section--main-product').appendChild(productStickyBar);
                }
            }
        }
            
        moveStickyBar();

        window.addEventListener('resize', function () {
            moveStickyBar();
        })

        
    })
}